var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box",staticClass:"image-box"},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.mediaObject.alt_text || ''}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }